// Video on ayarinin otomatik secimi.
//
// Uc kaynaktan beslenir, guclu olan zayifi ezer:
//   1. Aktif magazanin dikeyi (en zayif — sadece varsayilan)
//   2. Urun basligi/kategorisi (anahtar kelime)
//   3. Gorsel analizi (en guclu — occlusion tespiti on ayari zorlar)
//
// Neden magaza dikeyi tek basina yetmiyor: bir tekstil magazasinda da kupa,
// poster, canta satiliyor; hepsi "giyim" on ayariyla uretilirse model
// olmayan kumas hareketi uydurmaya calisiyor.

import type { Vertical } from "./useShopVertical";

/** Dikeyin varsayilan video on ayari. */
export function presetForVertical(vertical: Vertical): string {
  switch (vertical) {
    case "jewelry":
      return "taki";
    case "apparel":
      return "giyim";
    default:
      return "duz";
  }
}

const KEYWORDS: Array<{ preset: string; words: string[] }> = [
  {
    preset: "takı",
    words: [
      "necklace", "pendant", "bracelet", "ring", "earring", "anklet", "charm", "jewelry", "jewellery",
      "kolye", "bileklik", "yuzuk", "yüzük", "kupe", "küpe", "halhal", "taki", "takı",
    ],
  },
  {
    preset: "giyim",
    words: [
      "shirt", "tshirt", "t-shirt", "tee", "sweatshirt", "hoodie", "crewneck", "sweater", "tank top",
      "apparel", "garment",
      "tisort", "tişört", "sweat", "kapsonlu", "kazak", "atlet", "giyim",
    ],
  },
  {
    preset: "düz",
    words: [
      "mug", "poster", "canvas", "sticker", "tote", "pillow", "blanket", "print", "card", "notebook",
      "kupa", "bardak", "tablo", "canta", "çanta", "yastik", "yastık", "kartpostal", "defter",
    ],
  },
];

/**
 * Metinden on ayar cikarir. Eslesme yoksa null doner ki cagiran taraf
 * dikey varsayilanina dusebilsin — yanlis tahmin etmektense tahmin etmemek iyi.
 */
export function presetFromText(text?: string | null): string | null {
  if (!text) return null;
  const t = text.toLowerCase();
  for (const { preset, words } of KEYWORDS) {
    if (words.some((w) => t.includes(w))) return preset;
  }
  return null;
}

export interface DetectInput {
  vertical: Vertical;
  /** Urun basligi, mockup etiketi ya da listing adi */
  title?: string | null;
  /** Panelin kendi urun tipi anahtari (product-types) */
  productTypeKey?: string | null;
}

export interface DetectResult {
  presetId: string;
  /** Kullaniciya neden bu secildigini soyleyebilmek icin */
  reason: string;
}

export function detectPreset({ vertical, title, productTypeKey }: DetectInput): DetectResult {
  const fromKey = presetFromText(productTypeKey);
  if (fromKey) return { presetId: fromKey, reason: "ürün tipinden" };

  const fromTitle = presetFromText(title);
  if (fromTitle) return { presetId: fromTitle, reason: "ürün adından" };

  return { presetId: presetForVertical(vertical), reason: "mağaza dikeyinden" };
}
